import React from 'react';

const DataReportsContext = React.createContext('dataReport');

export const DataReportsContextProvider = DataReportsContext.Provider;

export default DataReportsContext;
